import { action } from 'typesafe-actions';
import { AuthTypes, RequestSignIn } from './types';

export const preSignInRequest = (preSignIn: RequestSignIn) =>
  action(AuthTypes.PRE_SIGN_IN_REQUEST, { preSignIn });

export const preSignInSuccess = (user: string[]) =>
  action(AuthTypes.PRE_SIGN_IN_SUCCESS, { user });

export const preSignFailure = () => action(AuthTypes.PRE_SIGN_FAILURE, {});

export const requestPwdRequest = (preSignIn: RequestSignIn) =>
  action(AuthTypes.REQUEST_PWD_SIGN_IN_REQUEST, { preSignIn });

export const requestPwdSuccess = () =>
  action(AuthTypes.REQUEST_PWD_SIGN_IN_SUCCESS, {});

export const requestPwdFailure = () =>
  action(AuthTypes.REQUEST_PWD_SIGN_FAILURE, {});

export const signInRequest = (signIn: RequestSignIn) =>
  action(AuthTypes.SIGN_IN_REQUEST, { signIn });

export const signInSuccess = (token: string) =>
  action(AuthTypes.SIGN_IN_SUCCESS, { token });

export const signFailure = () => action(AuthTypes.SIGN_FAILURE, {});

export const signOutRequest = () => action(AuthTypes.SIGNOUT_REQUEST, {});

export const signOutSuccess = () => action(AuthTypes.SIGNOUT_SUCCESS, {});

export const signOutFailure = () => action(AuthTypes.SIGNOUT_FAILURE, {});

export const signedRequest = () => action(AuthTypes.SIGNED_REQUEST, {});

export const setCountryCompany = (countryCompany: any) =>
  action(AuthTypes.SET_COUNTRY_COMPANY, { countryCompany });

export const companyRequest = (company: string) =>
  action(AuthTypes.COMPANY_REQUEST, { company });

export const companySuccess = (data: any) =>
  action(AuthTypes.COMPANY_SUCCESS, { data });

export const companyFailure = () => action(AuthTypes.COMPANY_FAILURE, {});

interface Data {
  infoHeader: any;
  token: string;
}

export const signedSuccess = (data: Data) =>
  action(AuthTypes.SIGNED_SUCCESS, { data });

export const signedFailure = () => action(AuthTypes.SIGNED_FAILURE, {});
